export const NestedLevelAddon = ({ level }: { level: number }) => {
  return (
    <div className="flex h-full gap-4 py-3">
      {new Array(level - 1).fill(0).map((_, i) => {
        return <NestedLevelIcon key={i} />;
      })}
    </div>
  );
};

const NestedLevelIcon = () => {
  return <div className="h-full w-px bg-gray-300" />;
};
